var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('div',{staticClass:"channel-ads inset",class:[_vm.position]},[_c('div',{staticClass:"inline-block"},[_c('img',{attrs:{"src":_vm.image}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }